// src/components/Login/PasswordCard.tsx
import React, { useState } from "react";
import i18n from "../../i18n/config";
import { reduxForm, Field, InjectedFormProps } from "redux-form";
import { ACTION_DISPLAY_TYPES } from "../../constants/enums";
import { PAGES } from "../../constants/localization";
import { ICON_SVG } from "../../constants/iconsvg";
import BrightwellBadge from "../../assets/images/icons/rebrand/brightwell-symbol-badge.svg";

// types
import {
  PasswordCardOwnProps,
  PasswordFormValues,
} from "../../types/components/Password";

// ui components
import Card from "../Common/Card";
import Action from "../Common/Action";
import ErrorBlock from "../Common/ErrorBlock";
import { Link } from "react-router-dom";

type PasswordCardProps = PasswordCardOwnProps &
  InjectedFormProps<PasswordFormValues, PasswordCardOwnProps>;

const PasswordCard = ({
  handleSubmit,
  submitting,
  errors,
  username,
  forgotPasswordLink,
}: PasswordCardProps) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Card
      icon={<img src={BrightwellBadge} alt="Brightwell Badge" />}
      title={
        <>
          {i18n.t("PAGES.AUTH.PASSWORD.CARD.TITLE")} {" "}<b>{username}</b>
        </>
      }
      wrapBody={false}
    >
      <form name="login" onSubmit={handleSubmit} className="v2" data-testid="password-form">
        <Card.Body>
          {errors && <ErrorBlock filterErrors={false} errors={errors} />}

          <div className="form-group mb-8">
            <label htmlFor="password" className="auth-label bold">
              {PAGES.AUTH.PASSWORD}
            </label>
            <div className="password-input">
              <Field
                id="password"
                component="input"
                name="password"
                type={showPassword ? "text" : "password"}
                autoFocus
                required
                disabled={submitting}
                autoComplete="current-password"
                className="form-control"
              />
              <button
                type="button"
                className="password-display-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? ICON_SVG.FULL_EYE : ICON_SVG.CROSSED_EYE}
              </button>
            </div>
          </div>
          <div className="text-right">
            <Link to={forgotPasswordLink} className="bold">
              {i18n.t("PAGES.AUTH.PASSWORD.CARD.FORGOT_PASSWORD")}
            </Link>
          </div>
        </Card.Body>

        <Card.Footer stretch>
          <Action
            title={i18n.t("COMMON.CONTINUE")}
            loading={submitting}
            displayType={ACTION_DISPLAY_TYPES.PRIMARY}
            type="submit"
            dataCy="password-submit"
            testId="password-submit"
            className="btn-md"
          />
        </Card.Footer>
      </form>
    </Card>
  );
};

export default reduxForm<PasswordFormValues, PasswordCardOwnProps>({
  form: "Password",
})(PasswordCard);